import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../../services/auth.service';
import { PermissionsEnum } from '../../../api/api-reference';

@Component({
  selector: 'app-settings-crud',
  standalone: true,
  imports: [TranslateModule, RouterOutlet],
  templateUrl: './settings-crud.component.html',
  styleUrl: './settings-crud.component.scss',
})
export class SettingsCrudComponent {
  PermissionsEnum=PermissionsEnum;
  constructor(private router: Router, public authService: AuthService) {}

  isActive(tab: string) {
    const currentRoute = this.router.url;
    if (currentRoute.includes(tab)) return true;
    else return false;
  }
  navigate(route: string) {
    this.router.navigate([route]);
  }
}
